module.exports = __webpack_public_path__ + "public/images/welcome_post_illustration.233274eda25a1b762325721b840d71b3.png";